// Pixel IDs. Each value here is a client-side public identifier —
// safe to commit. (Server-side secrets live in env vars; these are
// loaded by the browser anyway and visible in DevTools.)
//
// Single source of truth for components/consent/pixel-loader.tsx.

export const PIXEL_IDS = {
  meta: '1011714526973860',
  ga4: 'G-EZHN4X6FGE',
  clarity: 'kclrp73nv2',
  rb2b: 'G4N210HM386Z',
  koala: 'pk_115ea014b6f689223a64c9a4d3bea22cf238',
  apollo: '6632213303dcf606b3d495e3',
  leadsy: '16Zhv5zVoirK4khyJ',
  vector: 'ea67556a-7f44-45fa-9be2-a0ec93c45d8e',
  clickConnector: '38ed40-40470',
  ahrefs: 'UV1lIYr3Bf4vluL/Tc+mFw',
} as const

export type PixelKey = keyof typeof PIXEL_IDS
